export const backgroundColor = '#545A63';

/* eslint-disable */
if (!process.browser) {
    global.btoa = (str) => Buffer
    .from(str)
    .toString('base64');
}
/* eslint-enable */

const BORDER_SVGS = {
    'down-out': (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10000 20" preserveAspectRatio="none" width="100%" height="20">
            <polygon points="0,0 10000,0 5000,20" fill="__BG_COLOR__" />
        </svg>`
    ),
    'left-in': (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 10000" preserveAspectRatio="none" width="20" height="100%">
            <polygon points="20,10000 0,10000 20,5000" fill="__BG_COLOR__" />
            <polygon points="20,0 0,0 20,5000" fill="__BG_COLOR__" />
        </svg>`
    ),
    'right-out': (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 10000" preserveAspectRatio="none" width="20" height="100%">
            <polygon points="0,0 20,5000 0,10000" fill="__BG_COLOR__" />
        </svg>`
    ),
    'up-in': (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10000 20" preserveAspectRatio="none" width="100%" height="20">
            <polygon points="10000,20 10000,0 5000,20" fill="__BG_COLOR__" />
            <polygon points="0,20 0,0 5000,20" fill="__BG_COLOR__" />
        </svg>`
    )
};

export const borderImage = (type, backgroundColor) => {
    const image = BORDER_SVGS[type].replace(
        /__BG_COLOR__/g,
        backgroundColor
    );

    return `url('data:image/svg+xml;base64,${btoa(image)}')`;
};



// WEBPACK FOOTER //
// ./src/views/Home/base/Content/borders.js